<script lang="ts">
  import { observe } from "$lib/actions/observe";

  let {
    sectionLabel = "",
    headline = "",
    meta = "",
    intro = "",
    sections = [] as Array<{
      number?: string;
      title?: string;
      clauses?: Array<{
        number?: string;
        text?: string;
        items?: string[];
      }>;
    }>
  } = $props();
</script>

<section>
  <div class="container">
    <div class="legal-doc">
      <div class="legal-head fade-up" use:observe>
        {#if sectionLabel}
          <span class="section-label">{sectionLabel}</span>
        {/if}
        {#if headline}
          <h1>{headline}</h1>
        {/if}
        {#if meta}
          <p class="legal-meta">{meta}</p>
        {/if}
        {#if intro}
          <p class="copy">{intro}</p>
        {/if}
      </div>

      {#each sections as section}
        <section class="legal-section fade-up" use:observe>
          {#if section.title}
            <h2>{section.number ? `${section.number}. ` : ""}{section.title}</h2>
          {/if}
          {#each section.clauses ?? [] as clause}
            <div class="legal-clause">
              {#if clause.text}
                <p>
                  {#if clause.number}<span class="clause-no">{clause.number}</span>{/if}{clause.text}
                </p>
              {/if}
              {#if clause.items}
                <ul>
                  {#each clause.items as item}
                    <li>{item}</li>
                  {/each}
                </ul>
              {/if}
            </div>
          {/each}
        </section>
      {/each}
    </div>
  </div>
</section>

<style>
  .legal-doc {
    max-width: 75ch;
    margin-inline: auto;
    padding-block: var(--space-2xl, 4rem);
  }

  .legal-meta {
    color: var(--muted);
    font-size: 0.9rem;
    margin-bottom: var(--space-lg, 2rem);
  }

  .legal-section {
    margin-top: var(--space-xl, 3rem);
  }

  .legal-section h2 {
    font-size: 1.25rem;
    margin-bottom: var(--space-sm, 1rem);
  }

  .legal-clause {
    margin-bottom: var(--space-md, 1.25rem);
  }

  .legal-clause p {
    line-height: 1.7;
    color: var(--text, inherit);
  }

  .clause-no {
    display: inline-block;
    min-width: 3ch;
    margin-right: 0.5rem;
    font-variant-numeric: tabular-nums;
    color: var(--muted);
    font-weight: 600;
  }

  .legal-clause ul {
    margin: 0.5rem 0 0 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    color: var(--muted);
  }
</style>
